import type { SVGProps } from 'react'
const SvgSyEthereum = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width={24} height={24} {...props}>
		<path d="m499.9 740.7-297-175.4 297 418.5 297.2-418.5zm288.2-246.4L499.9 16.2 211.8 494.3l288.1-130.9zm8.8 14.7" />
		<path d="m213.1 515 286.8 169.5L786.7 515 499.9 384.6z" />
	</svg>
)
export default SvgSyEthereum
